const template =
    `<div 
        tabindex="0" 
        class="system__item-icons-item" 
        ng-class="{'oi_ico_disabled': vm.disabled && !vm.getIsIconRed(),  'oi_ico_disabled_red': vm.disabled && vm.getIsIconRed(), 'system__item-icons-item-red': vm.getIsIconRed()}" 
        tooltip-trigger="'mouseenter focus'" 
        tooltip-placement="top" 
        uib-tooltip="{{vm.tooltip}}" 
        tooltip-class="mytooltip" 
        tooltip-append-to-body="true"
        tooltip-popup-delay="200"
        role="img"
        aria-label="{{vm.tooltip}}">
            <svg height="24" width="24" viewBox="0 0 24 24" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">
                <use xlink:href="" ng-attr-xlink:href="{{vm.getIconCode()}}"/>
            </svg>
    </div>`;

/*@ngInject*/
module.exports = function () {
    return {
        scope: {
            code: '<',
            disabled: '=',
            tooltip: '<',
            isIconRed: '<',
        },
        restrict: 'E',
        replace: true,
        template,
		transclude: true,
        controllerAs: 'vm',
        bindToController: true,
        controller: function () {
            const vm = this;
            vm.getIconCode = () => {
                if (!vm.code) {
                    return null;
                }
                return '#' + vm.code;
            };

            vm.getIsIconRed = () => {
                const redIcons = [
                    'wheelchair_no_access', 'electric_wheelchair_no_access', 'scooter_no_access', 'baby_carriage_no_access',
                    'wheelchair_sign_at_a_bus_stop_no', 'lift', 'disabled_access_ramp_10', 'standard_door_manually_opened_narrow',
                    'high_border', 'steep_climb_on_the_sidewalk', 'dilapidated_sidewalk'
                ];

                return vm.isIconRed || redIcons.includes(vm.code);
            };
        }
    };
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/systemIcon.directive.js
 **/